import AddNewPrescription from '@components/pdp-contacts-prescriptions/my-new-prescription/AddNewPrescription';

const GuestUserPage = () => {
    return (
        <div className="presc-tab-selection guest-tab">
            <div className="presc-tab select-presc-guest active">Select your prescription</div>

            <AddNewPrescription showNoPrescriptionsAlert={false} />
        </div>
    );
};

export default GuestUserPage;
